import Vue from 'vue'
import Vuex from 'vuex'
import myPlace from './modules/myPlace'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    myPlace
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js